export const SearchAutosuggestType = {
  CATEGORY_SUGGESTIONS: 'categorySuggestions',
  PRODUCT_SUGGESTIONS: 'productSuggestions',
  TOP_SEARCH_SUGGESTIONS: 'topSearchSuggestions'
};
